import React, { useEffect, useState } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Axios from "axios";
import { GetMatchedcandidateList, GetJobRoles, GetCourseInfo } from "../apiconstants/constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';
import LoadingSpinner from "../helpers/loadingspinner";
import parse from "html-react-parser"
import DOMPurify from 'dompurify';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewMatchedCandidatebyId = () => {
    let query = useQuery();
    const guid = query.get("candidateID");
    const jobPostID = query.get("jobPostID");
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const jobDescription = location.state?.jobDescription;
    const jobRoleID = location.state?.jobRole;
    const clientEmail = location.state?.clientEmail;
    const clientName = location.state?.clientName;
    const updatedDateFilter = location.state?.updatedDateFilter;
    // etc.
    
    let Guid="";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });


    const GetCandidateDetails = async () => {
        const GetapiUrl = `${GetMatchedcandidateList.APIURL}?CandidateID=${guid}&JobPostID=${jobPostID}`;

        try {
            const result = await Axios.get(GetapiUrl);
            setCandidateDetails(result.data[0]);
        } catch (error) {
            console.error("Error fetching candidate details:", error);
        }
    };
    const handleVideoClick = (videoURL) => {
        setCurrentVideoUrl(videoURL);
        setShowModal(true);
      };

    const handleShowModal = (title, url) => {
        setModalContent({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const formatComments = (comments) => { 
      try {
          // Try parsing only if comments is a valid JSON string
          if (typeof comments === "string" && comments.startsWith("[")) {
              const parsedComments = JSON.parse(comments);
    
              // If it's an array, format properly
              if (Array.isArray(parsedComments)) {
                  return parsedComments.map((item, index) => (
                      <div key={index} style={{ marginBottom: 10 }}>
                          <p><strong>Question:</strong> {item.question}</p>
                          <p><strong>Answer:</strong> {item.CandidateResponse|| "No response provided"}</p>
                          <p><strong>Feedback:</strong> {item.AIEvaluationResponse || "No response provided"}</p>
                          <p><strong>Score:</strong> {item.Score}/5</p>
                          <hr />
                      </div>
                  ));
              }
          }
    
          // If it's not JSON (plain text), just display it inside <p>
          return <p>{parse(DOMPurify.sanitize(comments))}</p>;
    
      } catch (error) {
          console.error("Error parsing comments:", error);
          return <p>Error displaying comments.</p>;
      }
    };

    useEffect(() => {
        GetCandidateDetails();
    }, []);

    const handleNavigate = ()=>{
      navigate("/Employer/ViewMatchedInternalCandidates");
      
    }
   
    return (
        <ConsultantLayout>
            {candidateDetails ? (
               <div className="container-fluid"> 
               <div className='mb-3 mt-3' style={{ display: 'flex', alignItems: 'center' }}>
               <button onClick={handleNavigate} style={{ background: "none", border: "none" }}>
  <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16 }}></i>
</button>

                 <h2 style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>Candidate Details</h2>
               </div>
               <hr />
               <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                 <div className="row mt-2">
<h5 style={{color:'#00a7ac'}}> Post Details</h5>
{candidateDetails.jobTitle !== null && candidateDetails.jobTitle !== "null" && ( 
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobTitle">Job Title</Tooltip>}>
    <p className="text-para">
      <i className="fa fa-briefcase icons"></i> {candidateDetails.jobTitle}
    </p>
  </OverlayTrigger>
)}

{candidateDetails.jobLocation !== null && candidateDetails.jobLocation !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobLocation">Job Location</Tooltip>}>
    <p className="text-para">
      <i className="fa fa-map-marker-alt icons"></i> {candidateDetails.jobLocation}
    </p>
  </OverlayTrigger>
)}

{candidateDetails.billRate !== null && candidateDetails.billRate !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-billRate">Bill Rate</Tooltip>}>
    <p className="text-para">
      <i className="fa fa-dollar-sign icons"></i> {candidateDetails.billRate}
    </p>
  </OverlayTrigger>
)}

{candidateDetails.jobPositions !== null && candidateDetails.jobPositions !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobPositions">Number of Positions</Tooltip>}>
    <p className="text-para">
      <i className="fa fa-users icons"></i> {candidateDetails.jobPositions}
    </p>
  </OverlayTrigger>
)}

<h5 style={{color:'#00a7ac'}}> Technical Skillset:</h5>

{candidateDetails.jobRequirement !== null && candidateDetails.jobRequirement !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRequirement">Job Requirement</Tooltip>}>
    <div className="text-para">
      <i className="fa fa-file-alt icons"></i> {" "}
      <div dangerouslySetInnerHTML={{ __html: candidateDetails.jobRequirement }} />
    </div>
  </OverlayTrigger>
)}
      
<h5 style={{color:'#00a7ac'}}> Candiates Details</h5>
                  
                 <table className="table table-bordered" style={{ padding: '0.25rem' }}>
  <tbody>
    {candidateDetails.candidateName !== null && candidateDetails.candidateName !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-user icons"></i> Consultant Name</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-name">Consultant Name</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateName}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
    {candidateDetails.candidateContact !== null && candidateDetails.candidateContact !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-phone icons"></i> Contact</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-contact">Contact</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateContact}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
    {candidateDetails.candidateEmail !== null && candidateDetails.candidateEmail !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-envelope icons"></i> Email ID:</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateEmail}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
    {candidateDetails.candidateLinkedIn !== null && candidateDetails.candidateLinkedIn !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-graduation-cap icons"></i> LinkedIn</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-linkedin">LinkedIn</Tooltip>}>
            <p className="text-para">
              <a
                href={candidateDetails.candidateLinkedIn.startsWith('http') ? candidateDetails.candidateLinkedIn : `https://${candidateDetails.candidateLinkedIn}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {candidateDetails.candidateLinkedIn}
              </a>
            </p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
    {candidateDetails.candidateLocation !== null && candidateDetails.candidateLocation !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-plane icons"></i> Current Location</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-relocation">Current Location</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateLocation}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
     {candidateDetails.candidateAvailability !== null && candidateDetails.candidateAvailability !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-plane icons"></i> Availability</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-relocation">Availability</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateAvailability}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
    
    {candidateDetails.candidateAuthorization !== null && candidateDetails.candidateAuthorization !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-plane icons"></i> Current Visa & First US Entry:</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-relocation">Current Visa & First US Entry</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateAuthorization}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}

{candidateDetails.candidateRelocation !== null && candidateDetails.candidateRelocation !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-plane icons"></i>Willing to Relocate</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-relocation">Willing to Relocate</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateRelocation}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}

    {candidateDetails.ssn !== null && candidateDetails.ssn !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-dollar-sign icons"></i>SSN</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-billRate">SSN</Tooltip>}>
            <p className="text-para">{candidateDetails.ssn}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}

{candidateDetails.candidateEducation !== null && candidateDetails.candidateEducation !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-dollar-sign icons"></i>Education (Highest degree):</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-billRate">Education</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateEducation}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
  
 
    {candidateDetails.candidateTotalExperience !== null && candidateDetails.candidateTotalExperience !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-briefcase icons"></i> Total Experience</td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-experience">Total Experience</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateTotalExperience} years</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
        {candidateDetails.candidateRate !== null && candidateDetails.candidateRate !== "null" && (
      <tr>
        <td style={{ padding: '0.5rem' }}><i className="fa fa-briefcase icons"></i>Hourly rate (C2C/W2): </td>
        <td style={{ padding: '0.5rem' }}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-experience">Hourly Rate</Tooltip>}>
            <p className="text-para">{candidateDetails.candidateRate}</p>
          </OverlayTrigger>
        </td>
      </tr>
    )}
    
  </tbody>
</table>
{candidateDetails.resumeSkills !== null && candidateDetails.resumeSkills !== "null" && (
      
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resumeSkills">Resume Skills</Tooltip>}>
<p className="text-para mr-3">
  <span style={{ fontWeight: "bold", color: "#00a7ac" }}> Resume Skills:</span>
  {candidateDetails.resumeSkills
    ?.split(",") 
    .map(skill => skill.trim()) 
    .sort() 
    .join(", ")} 
</p>
          </OverlayTrigger>
      
    )}
                     {candidateDetails.jdSkills !== null && candidateDetails.jdSkills !== "null" && (
                       <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jdSkills">JD Skills</Tooltip>}>
                        <p className="text-para mr-3"><span style={{fontWeight:"bold",color:"#00a7ac"}}> JD Skills:</span>
                        {candidateDetails.jdSkills?.split(",") 
    .map(skill => skill.trim()) 
    .sort() 
    .join(", ")} </p>
                       </OverlayTrigger>
                     )}
                    
                    
                    
                      {candidateDetails.matchedSkills !== null && candidateDetails.matchedSkills !== "null" && (
                       <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-matchedSkills">Matched Skills</Tooltip>}>
                       <p className="text-para mr-3">
      <span style={{ fontWeight: "bold", color: "#00a7ac" }}>Matched Skills:</span>{" "}
      {candidateDetails.matchedSkills.trim() !== "" ? (
        candidateDetails.matchedSkills
          .split(",")
          .map(skill => skill.trim())
          .sort()
          .join(", ")
      ) : (
        <span>No matched skills found</span>
      )}
    </p>
                       </OverlayTrigger>
                     )}
                     {candidateDetails.matchedSkillsPercentage !== null && candidateDetails.matchedSkillsPercentage !== "null" && (
                       <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-matchedSkillsPercentage">Matched Skills Percentage</Tooltip>}>
                        <p className="text-para mr-3"><span style={{fontWeight:"bold",color:"#00a7ac"}}> Matched Skills Percentage:</span>{candidateDetails.matchedSkillsPercentage}</p>
                       </OverlayTrigger>
                     )}
                      
                      {candidateDetails.candidatesCertifications !== null && candidateDetails.candidatesCertifications !== "null" && candidateDetails.candidatesCertifications !== "[]" &&(
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-candCert">Candidate Certifications</Tooltip>}>
    <div className="text-para">
    <p className="text-para mr-3"><span style={{fontWeight:"bold",color:"#00a7ac"}}> Candidate Certifications:</span></p>
      <ul>
        {JSON.parse(candidateDetails.candidatesCertifications).map(cert => (
          <li key={cert.CertificationId}>{cert.CertificationName}</li>
        ))}
      </ul>
    </div>
  </OverlayTrigger>
)}

{candidateDetails.matchedCertifications !== null && candidateDetails.matchedCertifications !== "null" && 
candidateDetails.matchedCertifications !== "[]" &&( 
<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-matchCert">Matched Certifications</Tooltip>}>
<div className="text-para">
<p className="text-para mr-3"><span style={{fontWeight:"bold",color:"#00a7ac"}}> Matched Certifications:</span></p>

<ul style={{listStyle:'inside'}}>
{JSON.parse(candidateDetails.matchedCertifications).map(cert => (
<li key={cert.CertificationId}>{cert.CertificationName}</li>
))}
</ul>
</div>
</OverlayTrigger>
)}
             {candidateDetails.matchedKeyResponsibilitiesReason !== null && candidateDetails.matchedKeyResponsibilitiesReason !== "null" && 
             candidateDetails.matchedKeyResponsibilitiesReason !== "[]" &&(
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-matchKRReason">Matched Key Responsibilities Reasons</Tooltip>}>
    <div className="text-para">
    <p className="text-para mr-3"><span style={{fontWeight:"bold",color:"#00a7ac"}}> Matched Key Responsibilities Reasons:</span></p>

      <ul style={{listStyle:'inside'}}>
        {JSON.parse(candidateDetails.matchedKeyResponsibilitiesReason).map(reason => (
          <li key={reason.ReasonId}>{reason.Reason}</li>
        ))}
      </ul>
    </div>
  </OverlayTrigger>
)}        
     

     {candidateDetails.assessmentLink !== null && candidateDetails.assessmentLink !== "null" && (<h5 style={{color:'#00a7ac', fontWeight:'bold'}}> Assessment & Feedback</h5>)}


{candidateDetails.assessmentLink !== null && candidateDetails.assessmentLink !== "null" && (
                       <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-assessmentLink">Assessment Link</Tooltip>}>
                        
                           <p className="text-para"><i className="fa fa-video icons"></i> <a href="#!" style={{fontSize:18}} onClick={() => handleVideoClick(candidateDetails.videoURL)}>View Assessment</a></p>

                       </OverlayTrigger>
                     )}

{candidateDetails.assessmentRating !== null && candidateDetails.assessmentRating !== "null" && (
                       <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-assessmentLink">Assessment Rating</Tooltip>}>
                        
                           <p className="text-para"><i className="fa fa-star icons"></i> <span style={{fontWeight:"bold",color:"#00a7ac"}}> Rating:</span> {candidateDetails.assessmentRating}</p>

                       </OverlayTrigger>
                     )}

{candidateDetails.assessmentFeedback !== null && candidateDetails.assessmentFeedback !== "null" && (
                       <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-assessmentLink">Assessment Feedback</Tooltip>}>
                           <p className="text-para"><i className="fa fa-star icons"></i><span style={{fontWeight:"bold",color:"#00a7ac"}}> Feedback:</span>
                           <div>{formatComments(candidateDetails.assessmentFeedback)}</div>
                           </p>
                       </OverlayTrigger>
                     )}


                 </div>
               </div>
       
               {showModal && (
  <div style={{height:'auto'}}>
 
    <div className="iframe-container">
        <iframe 
          src={candidateDetails.assessmentLink} 
          sandbox="allow-scripts allow-same-origin" 
          className="responsive-iframe" 
          allow="autoplay"
        ></iframe>
      </div>  
  </div>
)}      </div>
             
            ) : (
                <center><LoadingSpinner /></center>
            )}
        
        </ConsultantLayout>
    );
};

export default ViewMatchedCandidatebyId;






